<template>
  <div class="safe-area relative flex flex-col items-center w-full">
    <div class="left-btn absolute p-3">
      <slot name="leftBtn" />
    </div>
    <div class="right-btn absolute p-3">
      <slot name="rightBtn" />
    </div>
    <!-- Head -->
    <div class="head flex flex-col items-center mb-4 mt-24 sm:mt-40 lg:mt-56">
      <img class="mt-5 mx-5" src="../../assets/common/logo-dark.svg" alt="Cloudzet" />
      <h3 v-if="headText" class="mt-5 text-xl text-center">{{ headText }}</h3>
    </div>
    <slot name="content" />
    <c-button v-if="nextBtnText" class="my-10 text-white" @click="$emit('next')">
      {{ nextBtnText }}
    </c-button>
    <slot />
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'Page',
  components: { CButton },
  props: {
    headText: String,
    nextBtnText: String,
    back: String,
    cancel: String,
  },
};
</script>

<style lang="scss" scoped>
.right-btn {
  top: 5vh;
  right: 1.75rem;
}

.left-btn {
  @extend .right-btn;
  left: 1.75rem;
  right: unset;
}
</style>
